/**
 * Configurazione condivisa degli slot di acquisizione foto per l'analisi
 * tricologica multiluce.
 *
 * Ordine FISSO e vincolante: il backend assume questo esatto ordine di
 * invio per le tre viste — stessa zona (vertex) in tre modalità di luce.
 *
 * Usato da: pages/NewAnalysis.jsx (slot upload) e
 *           components/TrichoBetaCapture.jsx (flusso guidato tricocamera).
 */
export const ANALYSIS_SLOTS = [
  {
    id: "vertex-bianca",
    label: "Vertex — Luce Bianca",
    desc: "Aspetto generale, colore e texture",
    tip: "Inquadra la sommità del capo — luce bianca",
    group: "vertex",
  },
  {
    id: "vertex-polarizzata",
    label: "Vertex — Luce Polarizzata",
    desc: "Cute, osti e sebo reale (lettura principale)",
    tip: "Stessa zona vertex — luce polarizzata",
    group: "vertex",
  },
  {
    id: "vertex-uv",
    label: "Vertex — Luce UV",
    desc: "Accumuli e depositi in fluorescenza",
    tip: "Stessa zona vertex — luce UV",
    group: "vertex",
  },
];

export const SLOT_GROUPS = [
  {
    key: "vertex",
    title: "Zona vertex — tre letture di luce",
    subtitle: "Stessa area, tre illuminazioni complementari",
  },
];
